import { DialogComponent } from '@theme/dialog';

const LEAD_API_URL = 'https://api.ajjas.com/gl/ajjas/forms/addLeads';

class BulkOrderStripComponent extends DialogComponent {
  requiredRefs = ['dialog', 'form', 'formView', 'thankYouView', 'submitButton', 'submitButtonText', 'formError'];
  #defaultSubmitText;

  connectedCallback() {
    super.connectedCallback();
    this.#defaultSubmitText = this.refs.submitButtonText.textContent;
    this.addEventListener('dialog:close', this.#resetToForm);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('dialog:close', this.#resetToForm);
  }

  async handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.refs.form);
    const mobile = (formData.get('phone') || '').replace(/\D/g, '');

    if (mobile.length !== 10) {
      this.#setError('Enter a valid 10-digit mobile number.');
      return;
    }

    const payload = {
      nm: formData.get('full_name') || '',
      mob: mobile,
      eml: formData.get('email') || '',
      msg: `${formData.get('message') || ''}\n\nSubmitted from: ${window.location.href}`,
      fromPage: window.location.pathname,
      bulkOrder: true,
      productName: formData.get('product_name') || '',
      quantity: formData.get('quantity') || '',
    };

    this.#setError('');
    this.#setSubmitting(true);

    try {
      const response = await fetch(LEAD_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.data || 'Something went wrong. Please try again.');
      }

      this.refs.formView.classList.remove('is-active');
      this.refs.thankYouView.classList.add('is-active');
      this.refs.form.reset();
    } catch (error) {
      console.error(error);
      this.#setError(error.message || 'Something went wrong. Please try again.');
    } finally {
      this.#setSubmitting(false);
    }
  }

  #setSubmitting(isSubmitting) {
    this.refs.submitButton.setAttribute('aria-disabled', String(isSubmitting));
    this.refs.submitButtonText.textContent = isSubmitting ? 'Submitting…' : this.#defaultSubmitText;
  }

  #setError(message) {
    this.refs.formError.textContent = message;
    this.refs.formError.hidden = !message;
  }

  #resetToForm = () => {
    this.refs.thankYouView.classList.remove('is-active');
    this.refs.formView.classList.add('is-active');
    this.#setError('');
  };
}

if (!customElements.get('bulk-order-strip-component')) {
  customElements.define('bulk-order-strip-component', BulkOrderStripComponent);
}
